import React, { useEffect, useState } from 'react'
import { AcountingHeading } from '../common/AcountingHeading'
import { Item } from '../../../common/snippets'
import { Box, Button } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import { columnDefs, columnDefsForExcel, headerColDefs, statusList, getFranchiseePendingTopayData } from './constants'
import * as url from '../../Reports/oldReportsUrls'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getCityList, getFtlBkngBranchList, updateAlertError } from '../../../../store/common/common_action'
import { FranchiseePendingToPayUpdateData, getFranchiseePendingTopayRptData } from '../../../../store/reports/reports_action'
import { API_CACHE_DURATION } from '../../../common/constants'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const FranchiseePendingTopayReportNew = (props) => {
  const {
    data: { common, reports }, getCityList, getFtlBkngBranchList, getFranchiseePendingTopayRptData, updateAlertError
  } = props
  const { cityList } = common
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), srcCity: '', srcBranch: '', destCity: '', destBranch: '', status: statusList[0] })
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState([])
  const [brnchList, setBranchList] = useState([])
  const [srcCityList, setSrcCityList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [srcBranchList, setSrcBranchList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])
  const [selectAllLR, setSelectAllLR] = useState(false)
  const [selectedData, setSelectedData] = useState([])
  const [selectLr, setSelectLr] = useState('')
  const [columns, setColumns] = useState([])
  const [excelColumns, setExcelColumns] = useState([])
  const [resetFilters, setResetFilters] = useState(false)

  const reportName = 'Franchisee Pending ToPay'

  const [companySettings] = useAtom(companySettingsAtom)
  const [searchParams] = useSearchParams()
  const allownFormatLR = companySettings?.UseFormattedLRinReports

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, intUserID, strCompanyName } = loginData

  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
 
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getCityList(loginData, true, API_CACHE_DURATION)
      let BranchBody = {
        intUserID: intUserID,
        intCompanyID: intCompanyID,
        intCityID: 0,
        intBookingBranchID: -1
      }
      getFtlBkngBranchList(BranchBody).then((res) => {
        if (res.status === 'Success') {
          setBranchList(res?.Data?.Table)
        } else {
          setBranchList([])
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }, [intUserID])

  useEffect(() => {
    if (cityList?.length > 0) {
      let newData = [{ CityID: 0, CityName: 'All' }, ...cityList]
      setDestCityList(newData)
      setFilters((prev) => ({
        ...prev,
        srcCity: newData[0],
        destCity: newData[0],
      }))
    }
  }, [cityList])

  useEffect(() => {
    if (filters?.destCity) {
      let newList = []
      let branchData = []
      if (cityList?.length > 0) {
        if (filters?.destCity?.CityID === 0) {
          newList = [{ CityID: 0, CityName: 'All' }, ...cityList]
          branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
          setDestBranchList(branchData)
          setSrcCityList(newList)
        } else {
          let filterCity = cityList?.filter((val) => val.CityID !== filters?.destCity?.CityID)
          newList = [{ CityID: 0, CityName: 'All' }, ...filterCity]
          setSrcCityList(newList)
          let destBranchData = brnchList?.filter((val) => val?.CityID === filters?.destCity?.CityID)
          branchData = [{ BranchID: 0, BranchName: 'All' }, ...destBranchData]
          setDestBranchList(branchData?.length > 1 ? branchData : [])
        }
      }
      setFilters((prev) => ({
        ...prev,
        destBranch: branchData?.[0],
        srcCity: newList?.[0],
      }))
    }
  }, [filters?.destCity, brnchList])

  useEffect(() => {
    if (filters?.srcCity) {
      let branchData = []
      if (filters?.srcCity?.CityID === 0 && filters?.destCity?.CityID === 0) {
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
      } else if (filters?.srcCity?.CityID === 0 && filters?.destCity?.CityID !== 0) {
        let srcBranchData = brnchList?.filter((val) => val.CityID !== filters?.destCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]

      }
      else if (filters?.srcCity?.CityID !== 0 && filters?.destCity?.CityID === 0) {
        let srcBranchData = brnchList?.filter((val) => val?.CityID === filters?.srcCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]
      } else {
        let srcBranchData = brnchList?.filter((val) => val?.CityID === filters?.srcCity?.CityID && val?.CityID !== filters?.destCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]
      }
      setSrcBranchList(branchData?.length > 1 ? branchData : [])
      setFilters((prev) => ({
        ...prev,
        srcBranch: branchData?.[0]
      }))
    }
  }, [filters?.srcCity, brnchList])

  useEffect(() => {
    if (allownFormatLR === 1 || allownFormatLR === 0) {
      setColumns(columnDefs)
      setExcelColumns(columnDefsForExcel)
    } else if (allownFormatLR === 2) {
      let newCols = [...columnDefs]
      let newExcelCols = [...columnDefsForExcel]
      newCols[1].header = 'Formatted LR'
      newCols[1].dataKey = 'FormattedLRNO'
      setColumns(newCols)
      newExcelCols[1].header = 'Formatted LR'
      newExcelCols[1].dataKey = 'FormattedLRNO'
      setExcelColumns(newExcelCols)
    } else if (allownFormatLR === 3) {
      let newCols = [...columnDefs]
      newCols[1].headerSx.width = '10%'
      newCols[3].headerSx.width = '8%'
      const newObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '9%', textAlign: 'left' } }
      newCols.splice(2, 0, newObject);
      setColumns(newCols);
      let newExcelCols = [...columnDefsForExcel]
      const newExcelObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 } }
      newExcelCols.splice(2, 0, newExcelObject);
      setExcelColumns(newExcelCols);
    }
  }, [allownFormatLR, columnDefs])
  const handleClick1 = async (isPdf = false) => {
    if (Math.abs(filters?.toDate.diff(filters?.fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    } else if (filters?.srcCity === '') {
      updateAlertError({ show: true, msg: 'Please Select Source City', nextId: 'srcCity' })
      return
    } else if (filters?.srcBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select Source Branch', nextId: 'srcBranch' })
      return
    } else if (filters?.destCity === '') {
      updateAlertError({ show: true, msg: 'Please Select Destination City', nextId: 'destCity' })
      return
    } else if (filters?.destBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select Destination Branch', nextId: 'destBranch' })
      return
    } else if (filters?.status === '') {
      updateAlertError({ show: true, msg: 'Please Select Status', nextId: 'status' })
      return
    }

    const body = {
      CompanyID: intCompanyID,
      BookingCityID: filters?.srcCity?.CityID,
      BookingBranchID: filters?.srcBranch?.BranchID,
      DestinationCityID: filters?.destCity?.CityID,
      DestinationBranchID: filters?.destBranch?.BranchID,
      dtFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
      dtToDate: moment(filters?.toDate).format('YYYY-MM-DD'),
      Status: filters?.status?.id,
      UserID: intUserID
    }

    const reportData = await getFranchiseePendingTopayData(body, updateAlertError)
    if (!reportData) return

    const reportPayload = {
      id: 'franchisee_pending_to_pay_report',
      reportName, reportData,
      filters, loginData,
      columns, excelColumns,
      allownFormatLR,
      saveMeta: body
    }

    if (isPdf === true) {
      const pdfCriteriaHeaders = headerColDefs.map(col => ({
        header: col.header,
        field: col.dataKey,
        xlCol: col.xlCol,
      }))

      const pdfCriteriaData = [{
        fromDate: moment(filters?.fromDate).format('DD-MMM-YYYY'),
        toDate: moment(filters?.toDate).format('DD-MMM-YYYY'),
        srcCity: filters?.srcCity?.CityName || '',
        srcBranch: filters?.srcBranch?.BranchName || '',
        destCity: filters?.destCity?.CityName || '',
        destBranch: filters?.destBranch?.BranchName || '',
        status: filters?.status?.name || '',
        dataType: 'entry',
      }]

      const flatTableData = reportData.flatMap(group => [
        {
          dataType: 'subHeader',
          GeneratedDateTime: group.GeneratedDateTime,
          colSpan: { 'GeneratedDateTime': (excelColumns.length > 0 ? excelColumns : columnDefsForExcel).length },
          align: { 'GeneratedDateTime': 'left' },
        },
        ...group.toPayData.map(row => ({
          ...row,
          IsReceived: row.IsReceived === 1 ? 'Yes' : row.IsReceived === 0 ? 'No' : '',
          dataType: row.isTotalRow ? 'total' : 'entry',
        })),
      ])

      const visibleCols = (excelColumns.length > 0 ? excelColumns : columnDefsForExcel).map(col => ({
        ...col,
        field: col.dataKey,
        exportHead: col.header,
        xlCol: col.xlCol || { dataType: 'string' },
        weight: col.weight || 80,
      }))

      downloadPDF({
        reportName,
        criteriaHeaders: pdfCriteriaHeaders,
        criteriaData: pdfCriteriaData,
        tableData: flatTableData,
        visibleColumns: visibleCols,
        loginData,
        hideHeader: false,
      })
      return
    }

    const rid = Date.now().toString()

    if (!window.generatedReports) {
      window.generatedReports = {}
    }
    window.generatedReports[rid] = reportPayload
    window.open(`/view-reportV2?rid=${rid}`, "_blank")
  }
  const handleClick2 = () => {
    let url = url.franchiseePendingToPayReport
    const urlData = url.franchiseePendingToPayReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDate = moment(filters?.fromDate).format('DD-MMM-YYYY')
    urlData.ToDate = moment(filters?.toDate).format('DD-MMM-YYYY')
    urlData.BookingCityId = filters?.srcCity?.CityID
    urlData.BookingBranchId = filters?.srcBranch?.BranchID
    urlData.DestinationCityId = filters?.destCity?.CityID
    urlData.DestinationBranchId = filters?.destBranch?.BranchID
    urlData.intStatus = filters?.status?.id
    urlData.UserId = intUserID
    urlData.BookingCityName = filters?.srcCity?.CityName
    urlData.BookingBranchName = filters?.srcBranch?.BranchName
    urlData.DestinationCityName = filters?.destCity?.CityName
    urlData.DestinationBranchName = filters?.destBranch?.BranchName
    urlData.strStatus = filters?.status?.name
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const handleReset = () => {
    setFilters({ fromDate: moment(new Date()), toDate: moment(new Date()), srcCity: '', srcBranch: '', destCity: '', destBranch: '', status: statusList[0] })
    setShowTable(false)
    setTableData([])
    setSelectAllLR(false)
    setSelectedData([])
    setSelectLr('')
    setResetFilters(true)
    setTimeout(() => {
      setResetFilters(false)
    }, 0);
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <AcountingHeading reportName={reportName} />}
      </Item>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { flexWrap: 'nowrap' }) }}>
        {!isFromUrl && <>
          <Item sx={{ ...sx.itemsx, width: '17%' }}>
            <DropDownOA
              id='company'
              label={'Select Company'}
              defaultvalue={strCompanyName}
              disabled={true}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
        </>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            id='fromDate'
            value={filters?.fromDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              setShowTable(false)
              focusElemnt('toDate')
            }}
            width="100%"
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            id='toDate'
            value={filters?.toDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              setShowTable(false)
              focusElemnt('destCity')
            }}
            width="100%"
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={{ ...(isFromUrl ? sx.itemsxGrow : sx.itemsx), width: isFromUrl ? '100%' : '17%' }}>
          <DropDownOA
            id={'destCity'}
            label={'Destination City'}
            data={destCityList || []}
            defaultvalue={filters?.destCity?.CityName}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                destCity: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Destination City`}
            width="100%"
            nextId={'destBranch'}
            prevId={'toDate'}
          />
        </Item>
        <Item sx={{ ...(isFromUrl ? sx.itemsxGrow : sx.itemsx), width: isFromUrl ? '100%' : '17.5%' }}>
          <DropDownOA
            id={'destBranch'}
            label={'Detination Branch'}
            data={destBranchList || []}
            defaultvalue={filters?.destBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                destBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Detination Branch`}
            width="100%"
            nextId={'srcCity'}
            prevId={'destCity'}
          />
        </Item>
        <Item sx={{ ...(isFromUrl ? sx.itemsxGrow : sx.itemsx), width: isFromUrl ? '100%' : '17%' }}>
          <DropDownOA
            id={'srcCity'}
            label={'Source City'}
            data={srcCityList || []}
            defaultvalue={filters?.srcCity?.CityName}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                srcCity: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Source City`}
            width="100%"
            nextId={'srcBranch'}
            prevId={'destBranch'}
          />
        </Item>
      </Box>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { flexWrap: 'nowrap' }) }}>
        <Item sx={{ ...(isFromUrl ? sx.itemsxGrow : sx.itemsx), width: isFromUrl ? '100%' : '17%' }}>
          <DropDownOA
            id={'srcBranch'}
            label={'Source Branch'}
            data={srcBranchList || []}
            defaultvalue={filters?.srcBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                srcBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Source Branch`}
            width="100%"
            nextId={'status'}
            prevId={'srcCity'}
          />
        </Item>
        <Item sx={{ ...(isFromUrl ? sx.itemsxGrow : sx.itemsx), width: isFromUrl ? '100%' : '17.6%' }}>
          <DropDownOA
            id={'status'}
            label={'Status'}
            data={statusList || []}
            defaultvalue={filters?.status?.name}
            idKey={`id`}
            dataKey={`name`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                status: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Status`}
            width="100%"
            nextId={'splitButton'}
            prevId={'destBranch'}
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'splitButton'}>
            DOWNLOAD PDF
          </Button> : <>
            <Item
              sx={sx.itemsx}
              onKeyDown={(e) => navigation3(e, 'refreshBtn', 'status', () => handleClick1())}
            >
              <SplitButton
                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                id1={'splitButton'}
                onClick1={handleClick1}
                onClick2={handleClick2}
              />
            </Item>
            <Item
              sx={{ ...sx.itemsx, padding: '5px 5px' }}
              id='refreshBtn'
              tabIndex={0}
              onKeyDown={(e) => navigation3(e, showTable ? 'excelBtn' : 'fromDate', 'splitButton', () => handleReset())}
              onClick={() => {
                handleReset()
              }}
            >
              <RefreshSvg />
            </Item>
          </>}
      </Box>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getCityList, getFtlBkngBranchList, getFranchiseePendingTopayRptData, FranchiseePendingToPayUpdateData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseePendingTopayReportNew)

